export function simplifyURL (url) {
  if (!url) return null
  url = url.substring(url.indexOf('//') + 2)

  const slashPos = url.indexOf('/')
  if (slashPos !== -1) url = url.substring(0, slashPos)
  if (url.startsWith('www.')) url = url.substring(4)

  return url
}
